import React from 'react'
import classNames from 'classnames'
import { Paper, Typography } from '@mui/material'
import { mezzoBrightnessValues } from '@app/lib/Scenes/mezzoBrightnessValues'
import {
  CREATE_ACTION_SELECTED,
  EDIT_ACTION,
  SELECT_BRIGHTNESS_ACTION_STATE_SELECTED,
  SELECT_MEZZO_ACTION_STATE_TYPE,
} from '@app/constants/routes'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import CardBlock from '@app/components/Common/iOS/CardBlockIOS/CardBlock'
import NavBar from '@app/components/Common/iOS/NavBarIOS/NavBar'
import PropTypes from '@app/components/PropTypes'
import restoreEditedActionInfo from '@app/helpers/scenes/restoreEditedActionInfo'

class SelectBrightnessValue extends React.Component {
  onBackClick = () => {
    const {
      navigate,
      deactivateChangeSensorStateMode,
      isChangeSensorStateMode,
      isEditActionMode,
      isChangeActionMode,
      isChangeActionStateMode,
      restoreActionInfo,
      actions,
      initialAction,
    } = this.props
    if (isEditActionMode) {
      restoreActionInfo()
      restoreEditedActionInfo(actions, initialAction)
      navigate(EDIT_ACTION)
    } else if (isChangeActionMode || isChangeActionStateMode) {
      navigate(CREATE_ACTION_SELECTED)
    } else if (isChangeSensorStateMode) {
      navigate(SELECT_BRIGHTNESS_ACTION_STATE_SELECTED)
    } else {
      navigate(SELECT_MEZZO_ACTION_STATE_TYPE)
    }
    deactivateChangeSensorStateMode()
  }

  onAddClick=(value) => {
    const {
      navigate,
      saveActionStateDescription,
      saveActionDuration,
      saveActionDurationDescription,
      saveActionDurationValueAfter,
      isChangeActionStateMode,
      isChangeActionMode,
      saveActionType,
      deactivateChangeSensorStateMode,
    } = this.props
    saveActionStateDescription(value.description)
    saveActionType('LightMezzo')
    if (isChangeActionStateMode || isChangeActionMode) {
      saveActionDuration({})
      saveActionDurationDescription('')
      saveActionDurationValueAfter('none')
    }
    deactivateChangeSensorStateMode()
    navigate(SELECT_BRIGHTNESS_ACTION_STATE_SELECTED)
  }

  render() {
    const {
      classes,
      isMobile,
    } = this.props
    return (
      <Paper className={classNames(
        classes.wrapper,
        (navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv'))
        && classes.webView,
      )}
      >
        <NavBar
          title="create_scene"
          withButton={false}
          isMobile={isMobile}
          backClick={() => {
            this.onBackClick()
          }}
        />
        <Wrapper className={classes.titleWrapper}>
          <Typography className={classes.title}>{I18n.t('scene_action_web.colour_settings')}</Typography>
        </Wrapper>
        <Wrapper className={classes.main}>
          {
            mezzoBrightnessValues.map((value) => (
              <CardBlock
                key={value.description}
                title={value.title}
                description={I18n.t(`scene_action_web.${value.description}`)}
                position={value.position}
                buttonName={value.buttonName}
                isCardDisabled={value.isCardDisabled}
                isButtonDisabled={value.isButtonDisabled}
                isValueButton
                onClick={() => {
                  this.onAddClick(value)
                }}
              />
            ))
          }
        </Wrapper>
      </Paper>
    )
  }
}

SelectBrightnessValue.propTypes = {
  classes: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  saveActionStateDescription: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  saveActionDuration: PropTypes.func.isRequired,
  saveActionDurationDescription: PropTypes.func.isRequired,
  saveActionDurationValueAfter: PropTypes.func.isRequired,
  isChangeActionStateMode: PropTypes.bool.isRequired,
  isChangeActionMode: PropTypes.bool.isRequired,
  saveActionType: PropTypes.func.isRequired,
  deactivateChangeSensorStateMode: PropTypes.func.isRequired,
  isChangeSensorStateMode: PropTypes.bool.isRequired,
  isEditActionMode: PropTypes.bool.isRequired,
  restoreActionInfo: PropTypes.func.isRequired,
  actions: PropTypes.arrayOf(PropTypes.action).isRequired,
  initialAction: PropTypes.action.isRequired,
}

SelectBrightnessValue.displayName = 'SelectBrightnessValueIOS'

export default SelectBrightnessValue
